import { axiosLabAPI } from 'services/axios';
import { API_POST_METHOD } from 'global_config/constant-global';
import { showMessage } from 'services/settings/message';

/**
 * Checks for dependencies of an item before deactivation.
 * @param {string} itemType - 'Exam Request', 'Exam Result', 'Section', 'Specimen', or 'Range Class Label'
 * @param {number} itemId - The ID of the record.
 * @returns {Promise<Array|null>} - List of dependencies or null on error.
 */
export async function checkItemStatus(itemType, itemId) {
	const url = 'settings/status';
	try {
		const response = await axiosLabAPI({
			method: API_POST_METHOD,
			url,
			data: {
				p_item_type: itemType,
				p_item_id: itemId,
				p_action: 'CHECK',
			},
		});

		const { data } = await response;
		return data.RECORDS || [];
	} catch (e) {
		showMessage(e);
		return null;
	}
}

/**
 * Deactivates an item and cleans up its dependencies using the backend logic.
 * @param {string} itemType - 'Exam Request', 'Exam Result', 'Section', 'Specimen', or 'Range Class Label'
 * @param {number} itemId - The ID of the record.
 * @returns {Promise<object|null>} - API response or null on error.
 */
export async function deactivateItem(itemType, itemId) {
	const url = 'settings/status';
	try {
		const response = await axiosLabAPI({
			method: API_POST_METHOD,
			url,
			data: {
				p_item_type: itemType,
				p_item_id: itemId,
				p_action: 'DEACTIVE',
			},
		});

		const { data } = await response;
		return data;
	} catch (e) {
		showMessage(e);
		return null;
	}
}

